<template>
<div class="chapter">
<div class="inner_page">
<p class="fm_title"><a id="page_ix">Sigla</a></p><a id="page_ix">
<table cellpadding="2" width="100%">
<tbody><tr valign="top"><td>AN</td>
<td><i>Armed Neutrality</i>. See PV.</td></tr>
<tr valign="top"><td>BA</td>
<td><i>The Book on Adler</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1998.</td></tr>
<tr valign="top"><td>CA</td>
<td><i>The Concept of Anxiety</i>. Edited and translated by Reidar Thomte. Princeton: Princeton University Press, 1980.</td></tr>
<tr valign="top"><td>CD</td>
<td><i>Christian Discourses and The Crisis and a Crisis in the Life of an Actress</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1997.</td></tr>
<tr valign="top"><td>CI</td>
<td><i>The Concept of Irony with Continual Reference to Socrates</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1989.</td></tr>
<tr valign="top"><td>COR</td>
<td><i>The Corsair Affair</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1982.</td></tr>
<tr valign="top"><td>CUP</td>
<td><i>Concluding Unscientific Postscript to “Philosophical Fragments.”</i> Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1992.</td></tr>
<tr valign="top"><td>EO</td>
<td><i>Either/Or</i> (2 vols.). Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1987.</td></tr>
<tr valign="top"><td>EUD</td>
<td><i>Eighteen Upbuilding Discourses</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1990.</td></tr>
<tr valign="top"><td>FSE</td>
<td><i>For Self-Examination; Judge for Yourself!</i> Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1990.</td></tr>
<tr valign="top"><td>FT</td>
<td><i>Fear and Trembling</i>. Edited by C. Stephen Evans and Sylvia Walsh. Translated by Sylvia Walsh. Cambridge: Cambridge University Press, 2006.</td></tr>
<tr valign="top"><td>JFY</td>
<td><i>Judge for Yourself!</i> See FSE.</td></tr>
<tr valign="top"><td>JP</td>
<td><i>Søren Kierkegaard’s Journals and Papers</i> (7 vols.). Edited and translated by Howard V. Hong and Edna H. Hong. Bloomington: Indiana University Press, 1967–78.</td></tr>
<tr valign="top"><td>OMWA</td>
<td><i>On My Work as an Author</i>. See PV.</td></tr>
<tr valign="top"><td><a id="page_x">P</a></td>
<td><i>Prefaces; Writing Sampler</i>. Edited and Translated by Todd W. Nichol. Princeton: Princeton University Press, 1997.</td></tr>
<tr valign="top"><td>PC</td>
<td><i>Practice in Christianity</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1991.</td></tr>
<tr valign="top"><td>PF</td>
<td><i>Philosophical Fragments</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1985.</td></tr>
<tr valign="top"><td>PV</td>
<td><i>The Point of View for My Work as an Author</i>, “The Single Individual,” <i>On My Work as an Author</i>, and <i>Armed Neutrality</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1998.</td></tr>
<tr valign="top"><td>SLW</td>
<td><i>Stages on Life’s Way</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1988.</td></tr>
<tr valign="top"><td>SUD</td>
<td><i>The Sickness unto Death</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1980.</td></tr>
<tr valign="top"><td>TA</td>
<td><i>Two Ages: The Age of Revolution and the Present Age. A Literary Review</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1978.</td></tr>
<tr valign="top"><td>TM</td>
<td><i>“The Moment” and Late Writings</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1998.</td></tr>
<tr valign="top"><td>UDVS</td>
<td><i>Upbuilding Discourses in Various Spirits</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1993.</td></tr>
<tr valign="top"><td>WA</td>
<td><i>Without Authority</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1997.</td></tr>
<tr valign="top"><td>WL</td>
<td><i>Works of Love</i>. Edited and translated by Howard V. Hong and Edna H. Hong. Princeton: Princeton University Press, 1995.</td></tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_signal.vue?5512b04c